import { apiClient } from './api';
import { API_ENDPOINTS, APIHeadersWithAuth } from '../globalConstants';
import type { Credit } from '@/lib/types';

export async function listCredits(shopId: number | string): Promise<Credit[]> {
    const res = await apiClient.get<{ data: any[] }>(
        API_ENDPOINTS.credits.LIST(shopId),
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function settleCredit(
    shopId: number | string,
    id: number | string,
    amount: number,
    method?: string
): Promise<Credit> {
    const res = await apiClient.post<{ data: any }>(
        API_ENDPOINTS.credits.SETTLE(shopId, id),
        method ? { amount, paymentMethod: method } : { amount },
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}
